export const enum IconsEnum {
  ADJUSTMENTS_ALT_SOLID = 'adjustments_alt_solid',
  ADJUSTMENTS_OUTLINE = 'adjustments_outline',
  ANDROID = 'android',
  ANNOTATION_OUTLINE = 'annotation_outline',
  ANNOTATION_SOLID = 'annotation_solid',
  APPLE = 'apple',
  ARCHIVE_BOX_X_MARK = 'archive_box_x_mark',
  ARCHIVE_BOX_X_MARK_OUTLINE = 'archive_box_x_mark_outline',
  ARROW_CIRCLE_UP_SOLID = 'arrow_circle_up_solid',
  ARROW_DOWN = 'arrow_down',
  ARROW_DOWN_CIRCLE_OUTLINE = 'arrow_down_circle_outline',
  ARROW_DOWN_TRIANGLE_SOLID = 'arrow_down_triangle_solid',
  ARROW_LEFT = 'arrow_left',
  ARROW_LEFT_OUTLINE = 'arrow_left_outline',
  ARROW_NARROW_DOWN_SOLID = 'arrow_narrow_down_solid',
  ARROW_NARROW_RIGHT_SOLID = 'arrow_narrow_right_solid',
  ARROW_NARROW_UP_OUTLINE = 'arrow_narrow_up_outline',
  ARROW_NARROW_UP_SOLID = 'arrow_narrow_up_solid',
  ARROW_PATH_OUTLINE = 'arrow_path_outline',
  ARROW_RIGHT_SOLID = 'arrow_right_solid',
  ARROW_RIGHT_TRIANGLE_SOLID = 'arrow_right_triangle_solid',
  ARROW_SM_DOWN = 'arrow_sm_down',
  ARROW_SM_LEFT_OUTLINE = 'arrow_sm_left_outline',
  ARROW_U_TURN_LEFT_SOLID = 'arrow_u_turn_left_solid_icon',
  ARROW_UP_TRIANGLE_SOLID = 'arrow_up_triangle_solid',
  ARROWS_EXPAND_OUTLINE = 'arrows_expand_outline',
  ARROWS_EXPAND_SOLID = 'arrows_expand_solid',
  AT_SYMBOL = 'at_symbol',
  AV = 'av',
  AXIS_SOLID = 'axis_solid',
  BAN_SOLID = 'ban_solid',
  BAN_OUTLINE = 'ban_outline',
  BADGE_CHECK = 'badge_check',
  BAG_ADD_OUTLINE = 'bag_add_outline',
  BELL = 'bell',
  BELL_CROSSED_SOLID = 'bell_crossed_solid',
  BELL_OUTLINE = 'bell_outline',
  BLANK = 'blank',
  BLOCK = 'block',
  BLUE_BELL = 'blue_bell',
  BOOK_OPEN_SOLID = 'book_open_solid',
  BOOK_STACK_OUTLINE = 'book_stack_outline',
  BRIEFCASE_SOLID = 'briefcase_solid',
  BURNING = 'burning',
  CALENDAR_OUTLINE = 'calendar_outline',
  CALENDAR_SOLID = 'calendar_solid',
  CAMERA_SOLID = 'camera_solid',
  CASH = 'cash',
  CASH_OUTLINE = 'cash_outline',
  CELLS_SOLID = 'cells_solid',
  CHART_BAR = 'chart_bar',
  CHART_BAR_SQUARE_SOLID = 'chart_bar_square_solid',
  CHART_PIE = 'chart_pie',
  CHART_SQUARE_BAR = 'chart_square_bar',
  CHAT = 'chat',
  CHAT_ALT = 'chat_alt',
  CHAT_GPT = 'chat_gpt',
  CHAT_OUTLINE = 'chat_outline',
  CHECK = 'check',
  CHECK_CIRCLE_OUTLINE = 'check_circle_outline',
  CHECK_CIRCLE_SOLID = 'check_circle_solid',
  CHECK_OUTLINE = 'check_outline',
  CHECK_SQUARE_SOLID = 'check_square_solid',
  CHEVRON_DOUBLE_LEFT = 'chevron_double_left',
  CHEVRON_DOUBLE_RIGHT = 'chevron_double_right',
  CHEVRON_DOWN = 'chevron_down',
  CHEVRON_DOWN_SOLID = 'chevron_down_solid',
  CHEVRON_LEFT = 'chevron_left',
  CHEVRON_RIGHT = 'chevron_right',
  CHEVRON_UP = 'chevron_up',
  CIRCLE_OUTLINE = 'circle_outline',
  CIRCLE_SOLID = 'circle_solid',
  CLIPBOARD_CHECK_OUTLINE = 'clipboard_check_outline',
  CLIPBOARD_CHECK_SOLID = 'clipboard_check_solid',
  CLIPBOARD_DOCUMENT_CHECK_OUTLINE = 'clipboard_document_check_outline',
  CLIPBOARD_DOCUMENT_CHECK_SOLID = 'clipboard_document_check_solid',
  CLIPBOARD_LIST_OUTLINE = 'clipboard_list_outline',
  CLIPBOARD_LIST_SOLID = 'clipboard_list_solid',
  CLOCK = 'clock',
  CLOCK_CLOCKWISE_SOLID = 'clock_clockwise_solid',
  CLOCK_OUTLINE = 'clock_outline',
  CLOUD_UPLOAD_OUTLINE = 'cloud_upload_outline',
  CLOUD_UPLOAD_SOLID = 'cloud_upload_solid',
  CODE_BRACKET_SOLID = 'code_bracket_solid',
  COG = 'cog',
  COG_EMPTY = 'cog_empty',
  COLLAPSE_ALL_OUTLINE = 'collapse_all_outline',
  COLLECTION_OUTLINE = 'collection_outline',
  COLLECTION_SOLID = 'collection_solid',
  COLOR_BUCKET_SOLID = 'color_bucket_solid',
  COLOR_SWATCH_OUTLINE = 'color_swatch_outline',
  COLOR_SWATCH_SOLID = 'color_swatch_solid',
  COMMAND_OUTLINE = 'command_outline',
  CONTACT_SUPPORT = 'contact_support',
  CONTRAST_SOLID = 'contrast_solid',
  CONTENT_CLIP = 'content_clip',
  CONTENT_WRAP = 'content_wrap',
  COPY = 'copy',
  CORONA_SOLID = 'corona_solid',
  CREDIT_CARD_SOLID = 'credit_card_solid',
  CROP_SOLID = 'crop_solid',
  CROSS = 'cross',
  CROSSED_BELL = 'crossed_bell',
  CROWN_SOLID = 'crown_solid',
  CUBE_OUTLINE = 'cube_outline',
  CUBE_SOLID = 'cube_solid',
  CUBE_TRANSPARENT_OUTLINE = 'cube_transparent_outline',
  CUBE_TRANSPARENT_SOLID = 'cube_transparent_solid',
  CUBES_OUTLINE = 'cubes_outline',
  CURRENCY_DOLLAR_SOLID = 'currency_dollar_solid',
  CURRENCY_DOLLAR_ALT_OUTLINE = 'currency_dollar_alt_outline',
  CURSOR_CLICK_SOLID = 'cursor_click_solid',
  DATABASE_OUTLINE = 'database_outline',
  DIMENSIONS_SOLID = 'dimensions_solid',
  DOCUMENT_ARCHIVE_SOLID = 'document_archive_solid',
  DOCUMENT_AUDIO_SOLID = 'document_audio_solid',
  DOCUMENT_DOWNLOAD_OUTLINE = 'document_download_outline',
  DOCUMENT_DUPLICATE_OUTLINE = 'document_duplicate_outline',
  DOCUMENT_MEDIAS = 'document_medias',
  DOCUMENT_MINUS_SOLID = 'document_minus_solid',
  DOCUMENT_OUTLINE = 'document_outline',
  DOCUMENT_PDF_SOLID = 'document_pdf_solid',
  DOCUMENT_REPORT_OUTLINE = 'document_report_outline',
  DOCUMENT_REPORT_SOLID = 'document_report_solid',
  DOCUMENT_SOLID = 'document_solid',
  DOCUMENT_PLUS_OUTLINE = 'document_plus_outline',
  DOCUMENT_TABLE_OUTLINE = 'document_table',
  DOCUMENT_TEXT_OUTLINE = 'document_text',
  DOCUMENT_TEXT_SOLID = 'document_text_solid',
  DOCUMENT_UPLOAD_OUTLINE = 'document_upload_outline',
  DOCUMENT_UPLOAD_SOLID = 'document_upload_solid',
  DOCUMENT_VIDEO_SOLID = 'document_video_solid',
  DOTS_HORIZONTAL_OUTLINE = 'dots_horizontal_outline',
  DOTS_HORIZONTAL_SOLID = 'dots_horizontal_solid',
  DOTS_VERTICAL_SOLID = 'dots_vertical_solid',
  DOWN_ARROW = 'down_arrow',
  DOWNLOAD_OUTLINE = 'download_outline',
  DOWNLOAD_SOLID = 'download_solid',
  DRAW_CURVE_OUTLINE = 'draw_curve_outline',
  DUPLICATE_SOLID = 'duplicate_solid',
  DUPLICATE_PENCIL_SOLID = 'duplicate_pencil_solid',
  ELASTIC_SEARCH_SOLID = 'elastic_search_solid',
  EMAIL_SOLID = 'email_solid',
  EMPTY_STAR = 'empty_star',
  EMPTY_STAR_OFF = 'empty_star_off',
  EMOJI_SAD_SOLID = 'emoji_sad_solid',
  ENVELOPE = 'envelope',
  EXCLAMATION = 'exclamation',
  EXCLAMATION_CIRCLE = 'exclamation_circle',
  EXCLAMATION_TRIANGLE = 'exclamation_triangle',
  EXCLAMATION_SOLID = 'exclamation_solid',
  EXTERNAL_LINK_SOLID = 'external_link_solid',
  EYE = 'eye',
  EYE_CROSSED = 'eye_crossed',
  EYE_OFF_OUTLINE = 'eye_off_outline',
  EYE_OFF_SOLID = 'eye_off_solid',
  EYE_OUTLINE = 'eye_outline',
  EYE_SOLID = 'eye_solid',
  EYE_SPLASH_SOLID = 'eye_splash_solid',
  FILLED_STAR = 'filled_star',
  FILTER = 'filter',
  FILTER_LIST_SOLID = 'filter_list_solid',
  FILTER_SOLID = 'filter_solid',
  FIRE_OUTLINE = 'fire_outline',
  FIRE_SOLID = 'fire_solid',
  FLAG = 'flag',
  FLAG_OFF_ALT_OUTLINE = 'flag_off_alt_outline',
  FLAG_OUTLINE = 'flag_outline',
  FOLDER_ALT_SOLID = 'folder_alt_solid',
  FOLDER_CUBE_SOLID = 'folder_cube_solid',
  FOLDER_DOWNLOAD = 'folder_download',
  FOLDER_FILE_SOLID = 'folder_file_solid',
  FOLDER_IMAGE_SOLID = 'folder_image_solid',
  FOLDER_MATERIAL_SOLID = 'folder_material_solid',
  FOLDER_OPEN_OUTLINE = 'folder_open_outline',
  FOLDER_RULERS_SOLID = 'folder_rulers_solid',
  FOLDER_SOLID = 'folder_solid',
  FOLDER_OUTLINE = 'folder_outline',
  FOLDER_OPEN_SOLID = 'folder_open_solid',
  FOLDER_X_SOLID = 'folder_x_solid',
  FOLDER_MOVE_OUTLINE = 'folder_move_outline',
  FOLDER_MOVE_SOLID = 'folder_move_solid',
  FOLDER_REMOVE_SOLID = 'folder_remove_solid',
  FORWARD = 'forward',
  FULLSCREEN_ENTER = 'fullscreen-enter',
  FULLSCREEN_EXIT = 'fullscreen-enter',
  HASH_OUTLINE = 'hash_outline',
  HAND_SOLID = 'hand_solid',
  HEART_OUTLINE = 'heart_outline',
  HEART_SOLID = 'heart_solid',
  HOME = 'home',
  HOURGLASS_OUTLINE = 'hourglass_outline',
  HOME_SOLID = 'home_solid',
  IDENTIFICATION = 'identification',
  INBOX_OUTLINE = 'inbox_outline',
  INFORMATION_CIRCLE_OUTLINE = 'information_circle_outline',
  INFORMATION_CIRCLE_SOLID = 'information_circle_solid',
  KEY = 'key',
  KEYBOARD_SOLID = 'keyboard_solid',
  LABEL_OUTLINE = 'label_outline',
  LABEL_SOLID = 'label_solid',
  LIGHTING_BOLT_SOLID = 'lighting_bolt_solid',
  LINK_CROSSED_ALT_SOLID = 'link_crossed_alt_solid',
  LINK_SOLID = 'link_solid',
  LIST_BULLET_ALT = 'list_bullet_alt',
  LIST_TODO_SOLID = 'list_todo_solid',
  LOCATION = 'location',
  LOCK_CLOSE = 'lock_close',
  LOCK_OPEN = 'lock_open',
  LOGOUT = 'logout',
  MAGNIFYING_GLASS_CIRCLE_SOLID = 'magnifying_glass_circle_solid',
  MAIL = 'mail',
  MAIL_OPEN = 'mail_open',
  MAIL_OUTLINE = 'mail_outline',
  MARKET_THRIVE = 'market_thrive',
  MATERIAL_OUTLINE = 'material_outline',
  MATERIAL_SOLID = 'material_solid',
  MEASURING_TAPE_ALT_SOLID = 'measuring_tape_alt_solid',
  MENU_ALT_SOLID = 'menu_alt_solid',
  MENU_OUTLINE = 'menu_outline',
  MENU_SOLID = 'menu_solid',
  MENU_TREE_SOLID = 'menu_tree_solid',
  MINUS_SM_SOLID = 'minus_sm_solid',
  MINUS_SOLID = 'minus_solid',
  MOUSE_WHEEL_SOLID = 'mouse_wheel_solid',
  NDA_SOLID = 'nda_solid',
  NEWSPAPER_SOLID = 'newspaper_solid',
  OFFICE_BUILDING_OUTLINE = 'office_building_outline',
  PAPER_AIRPLANE_SOLID = 'paper_airplane_solid',
  PAPER_CLIP_OUTLINE = 'paper_clip_outline',
  PAPER_CLIP_SOLID = 'paper_clip_solid',
  PAUSE_OUTLINE = 'pause_outline',
  PAUSE_ALT_OUTLINE = 'pause_alt_outline',
  PAUSE_SOLID = 'pause_solid',
  PENCIL = 'pencil',
  PENCIL_ALT_OUTLINE = 'pencil_alt_outline',
  PENCIL_ALT_SOLID = 'pencil_alt_solid',
  PENCIL_OUTLINE = 'pencil_outline',
  PHONE = 'phone',
  PHONE_SOLID = 'phone_solid',
  PHOTO_AI_SOLID = 'photo_ai_solid',
  PHOTO_SOLID = 'photo_solid',
  PHOTOGRAPH_OUTLINE = 'photograph_outline',
  PHOTOGRAPH_SOLID = 'photograph_solid',
  PERCENT_OUTLINE = 'percent_outline',
  PIN = 'pin',
  PUSHPIN_OUTLINE = 'pushpin_outline',
  PUSHPIN_OFF_OUTLINE = 'pushpin_off_outline',
  PUSHPIN_SOLID = 'pushpin_solid',
  PLAY_OUTLINE = 'play_outline',
  PLAY_ALT_OUTLINE = 'play_alt_outline',
  PLAY_SOLID = 'play_solid',
  PLUS = 'plus',
  PLUS_CIRCLE_OUTLINE = 'plus_circle_outline',
  PLUS_OUTLINE = 'plus_outline',
  PLUS_SM_SOLID = 'plus_sm_solid',
  PLUS_SOLID = 'plus_solid',
  PROJECTS = 'projects',
  PULSE_OUTLINE = 'pulse_outline',
  PULSE_SOLID = 'pulse_solid',
  PULSE_SOLID_ALT = 'pulse_solid_alt',
  QUESTION_MARK_CIRCLE_OUTLINE = 'question_mark_circle_outline',
  QUESTION_MARK_OUTLINE = 'question_mark_outline',
  QUESTION_MARK_CIRCLE_SOLID = 'question_mark_circle_solid',
  REACT = 'react',
  RECEIPT_REFUND = 'receipt_refund',
  RECEIPT_REFUND_OUTLINE = 'receipt_refund_outline',
  REFRESH = 'refresh',
  REFRESH_SOLID = 'refresh_solid',
  RENAME_SOLID = 'rename_solid',
  REPLY_OUTLINE = 'reply_outline',
  REPLY_SOLID = 'reply_solid',
  ROCKET_OUTLINE = 'rocket_outline',
  ROCKET_SOLID = 'rocket_solid',
  RULERS_OUTLINE = 'rulers_outline',
  RULERS_SOLID = 'rulers_solid',
  SEARCH = 'search',
  SEARCH_AI_OUTLINE = 'search_ai_outline',
  SEARCH_AI_SOLID = 'search_ai_solid',
  SEARCH_OUTLINE = 'search_outline',
  SELECTOR = 'selector',
  SERVER_SOLID = 'server_solid',
  SHIELD_CHECK_OUTLINE = 'shield_check_outline',
  SHIELD_CHECK_SOLID = 'shield_check_solid',
  SHIELD_EXCLAMATION = 'shield_exclamation',
  SMASHING_CGI = 'smashing_cgi',
  SMILE = 'smile',
  SORT_ASC = 'sort_asc',
  SORT_DESC = 'sort_desc',
  SPARKLES_SOLID = 'sparkles_solid',
  SPARKLES_OUTLINE = 'sparkles_outline',
  SQUARE_3_STACK_3D = 'square_3_stack_3d',
  SQUARE_3_STACK_3D_OUTLINE = 'square_3_stack_3d_outline',
  SQUARE_COMBINED_SOLID = 'square_combined_solid',
  SQUARE_EMPTY_SOLID = 'square_empty_solid',
  SQUARE_SEPARATE_SOLID = 'square_separate_solid',
  STARS_MULTIPLE_SOLID = 'stars_multiple_solid',
  STOP_OUTLINE = 'stop_outline',
  STOP_ALT_OUTLINE = 'stop_alt_outline',
  STOP_SOLID = 'stop_solid',
  SWITCH_HORIZONTAL_SOLID = 'switch_horizontal_solid',
  TABLE_SOLID = 'table_solid',
  TAG_OUTLINE = 'tag_outline',
  TAG_SOLID = 'tag_solid',
  TEMPLATE_SOLID = 'template_solid',
  TICKET_SOLID = 'ticket',
  TOP_ARROW = 'top_arrow',
  TRANSFER_INCOMING_SOLID = 'transfer_incoming_solid',
  TRANSFER_OUTGOING_SOLID = 'transfer_outgoing_solid',
  TRANSLATE = 'translate',
  TRASH_OUTLINE = 'trash_outline',
  TRASH_SOLID = 'trash_solid',
  TRENDING_DOWN_SOLID = 'trending_down_solid',
  TRENDING_UP_SOLID = 'trending_up_solid',
  UNITS_METRIC_CM_SOLID = 'units_metric_cm_solid',
  UNITS_METRIC_IN_SOLID = 'units_metric_in_solid',
  UPLOAD_OUTLINE = 'upload_outline',
  UPLOAD_SOLID = 'upload_solid',
  USER_ADD_OUTLINE = 'user_add_outline',
  USER_ADD_SOLID = 'user_add_solid',
  USER_CIRCLE = 'user_circle',
  USER_CIRCLE_SOLID = 'user_circle_solid',
  USER_GROUP = 'user_group',
  USER_GROUP_SOLID = 'user_group_solid',
  USER_ORGANIZATION = 'user_organization',
  USER_OUTLINE = 'user_outline',
  USER_SOLID = 'user_solid',
  USER_SUBTRACT_OUTLINE = 'user_subtract_outline',
  USER_SUBTRACT_SOLID = 'user_subtract_solid',
  USERS_SOLID = 'users_solid',
  VIDEO_CAMERA_SOLID = 'video_camera_solid',
  VIEW_COLUMNS = 'view_columns',
  VIEW_GRID = 'view_grid',
  VIEW_GRID_SM = 'view_grid_sm',
  VIEW_LIST = 'view_list',
  VIEW_LIST_SOLID = 'view_list_solid',
  VIEW_LIST_USER_SOLID = 'view_list_user_solid',
  VIEW_LIST_NO_SYMBOL_SOLID = 'view_list_no_symbol_solid',
  VIEW_LIST_QUESTION_SOLID = 'view_list_question_solid',
  VRAY_SOLID = 'vray_solid',
  WHITEBOARD_SOLID = 'whiteboard_solid',
  WINDOW_MINIMIZE_OUTLINE = 'window_minimize_outline',
  WITHDRAWAL_OUTLINE = 'withdrawal_outline',
  MESH_EDGES_OUTLINE = 'mesh_edges_outline',
  WIREFRAME_OUTLINE = 'wireframe_outline',
  WRENCH_SCREWDRIVER_OUTLINE = 'wrench_screwdriver_outline',
  X = 'x',
  X_CIRCLE = 'x_circle',
  X_CIRCLE_OUTLINE = 'x_circle_outline',
  X_OUTLINE = 'x_outline',
  ZOOM_IN_OUTLINE = 'zoom_in_outline'
}

export interface IconProps {
  className?: string;
  id?: string;
  strokeWidth?: string;
}
